import React, { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import styles from './filterChecklistStyles.scss';

const FilterChecklist: React.FC<{
  disabled?: boolean;
  filterList: { label: string; value: string }[];
  paramName: string;
  title?: string;
}> = ({ disabled, filterList, paramName, title }): React.ReactElement => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentParamValues = searchParams.getAll(paramName);

  const setParamValue = useCallback(
    (checked: boolean, paramValue: string) => {
      searchParams.set('page', '1');
      if (checked) {
        paramName.includes('[]')
          ? searchParams.append(paramName, paramValue)
          : searchParams.set(paramName, paramValue);
      } else {
        searchParams.delete(paramName, paramValue);
      }
      searchParams.delete('recommended');
      searchParams.delete('fpid');
      setSearchParams(searchParams);
    },
    [paramName, searchParams, setSearchParams]
  );

  return (
    <section className={styles.filterListArea}>
      {title && <label className={styles.title}>{title}</label>}
      {filterList.map(({ label, value }) => {
        const key = paramName + '_' + label;

        return (
          <div className={styles.filterListItemArea} key={key}>
            <input
              id={key}
              checked={currentParamValues.includes(value)}
              disabled={disabled}
              data-heap={key}
              onChange={({ target: { checked, value } }): void => setParamValue(checked, value)}
              name={paramName}
              type="checkbox"
              value={value}
            />
            <label htmlFor={key}>{label}</label>
          </div>
        );
      })}
    </section>
  );
};

export default FilterChecklist;
